(function($) {

	$('#form-product-variant-detail').change(load_product_variation_detail)

	function show_loading(){
		$('.product__variant_data').css({
			"opacity": "0.5",
			"pointer-events": "none"
		})
	}

	let request;

	function load_product_variation_detail(e){

		e.preventDefault()

		// Abort previous request if is loading
		if(typeof request !== "undefined"){
			request.abort()
		}

		// Show loading
		show_loading()

        let $this = $(this);

		let url = $this.attr("action"),
			data = $this.serializeArray().concat([
                    {
                        name: 'quantity',
                        value: $this.parent().find('input[name="quantity"]').val()
                    }
                ]); // add quantity info to keep it between changes

		request = gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data
		})
			.done((response, textStatus, jqXHR) => {
				jQuery( document ).trigger('product_variation_detail_loaded')
			})
	}

})(jQuery);
